<template>
  <div id="graph"></div>
</template>
<style type="text/css">
  .flow {
    stroke-dasharray: 8;
    animation: dash 0.5s linear;
    animation-iteration-count: infinite;
  }
  @keyframes dash {
    to {
      stroke-dashoffset: -16;
    }
  }
</style>
<script>


export default {
  data() {
    return {
      }
      // customPlugins: {
      //   checkboxSelectorPlugin: {
      //     register: true,
      //     plugin: checkboxSelector
      //   },
      //   // gridMenuControl: {
      //   //   register: true,
      //   //   plugin: gridMenu
      //   // }
      // },
      // columnOptions: {
      //   percentComplete: {
      //     editor: Editors.Text,
      //     groupTotalsFormatter(totals, columnDef) {
      //       let val = totals.avg && totals.avg[columnDef.field];
      //       if (val != null) {
      //         return "Avg: " + Math.round(val) + "%";
      //       }
      //       return "";
      //     }
      //   },
      //   cost: {
      //     groupTotalsFormatter(totals, columnDef) {
      //       let val = totals.sum && totals.sum[columnDef.field];
      //       if (val != null) {
      //         return "Total: " + ((Math.round(parseFloat(val)*100)/100));
      //       }
      //       return "";
      //     }
      //   }
      // }
    //};
  },
  created() {

  },
  mounted() {

    var graph = new Graph(document.getElementById('graph'));
		graph.resizeContainer = true;
    graph.setEnabled(false);

    var data = "7Vpdc6M2FP01ntk+lAEJMDz6c5tp15uJ0+32aUcG2WiDERUitvfXV4D4tj0bx4mhUzLjoCPpCumec7mSPYCT7f4jQ6H3ibrYHwDV3Q/gdADA0DLFZwIcMkDX7AzYMOJmkFYCS/IDS1CVaExcHNUackp9TsI66NAgwA7PMNkXMUZ3UQ1aU78+aog2uAUsHeS30b+Iy70MtQy1xH/DZOPJkTVNTWvgbAAnjFKe3W33E+wn65LPOes+P1FbDMpwwI90+DPC7PPqezJfoPpoJZY8bTQAxgJtsfgnDfjIwZ6YMmb11UpbpcCSI8YzcIojh5GQExq06n7H0n/Lx9HDY4YVT1vOuJhJxA/5CkYeCpPb7X6TMERZ+3TneMKywjHbkgBxygZwvPMIx8tQPLBouxMtBebxbTIzTdxGnNGnwgWwQCbUT7qLgaBtjg3LEDVr4vsVfGzP1FGCP6WTqMygusByZZ4x43hfgeS8PmK6xZwdRBNZq0sKHOrFXckSLWedV2GImZNTemRTGC79K27kSubFisevzYAH/Ezw7gQFviBG0MrHWosGs/sGC7SzLGA0DlyctFVf6mxwzNkjLfkTNdf3pGb11ZWjMGT0Gb/el+C/4kuoGT315SxwT/ixqCk8OFtMGw6E3QjJY8uGNmyH5Pl8Iq4iJBfPf03XG2ZfZbyMV1vCwam3clqbVa42Ex9FUT5SSgGRCbXAiCMeR1+QH+MqzLCDiVhgKWsUPH1YU7YdwBFyeIz8b7GYVPohiAUm2i+ym2hYNSNGdEn5gLntf2LCsLugvDYmijldchxWsYLIo8nj3edFg8v6WS5jV+RrskgZ9+iGBsiflei4Hq7KNn9QGkoqf8ecH2TymTxgnegnuRnRmDmNhFXkTBtcZIMZljzjWQZXKGocYWiOMewjLhxWe4hjtJUj3FMS8FIgmt1MWRrMz+Yje1Xz04ahVpQ1GoayRWgZSlVUTLtr78fbCQvcRlhGP4SVb/uqwgLdEpbWyCC1C4XVMmT3Q1gPODPzvrp6lWg4i/GlwjFvLRy8J/xr0l2xbVOW/07Lhm7I8nQv7aeFQ6VwL8KOYEq6jCkWCNZ8zU0nBWkLDnOgNJaWDtVS09zlqlY7pWoINcW01PIya9oUQUgBoFINL9M8hKpSsaJqtVGG5wf5Px50IR4MOxwPgP6KeKAkpK/HBB28XUwAr4gJUk2/qooOjfam/w3jhNhAKpbe1mh5BFHTdx5GXpx0m43sXVMMw65cxk+FhtJu3pCu1xHuVPgYOalej4ePauV103Tq4w/zu8VoMZl9G00/3S1ukpaD88fpnUnLj4gVdGu/C6yGYprZ9Ate0XVDej/S8jkJUCAcBtRrnQzXHNrrk2G9t1/YnPdlrbY76dWlwRD0IhiCY7sZ2Klg2DxagFYjX7j0jELvyeHf2T3JmyUVNxHN+W9/3nE/Umwgyv3IdXcj5tudUBzV9Mt3I8bQslovmvdMegxNMUHdyk9vOYZ1W6D5hcF77zEEVP6oJrNQ/uoIzv4F";
    var wfdataraw = Graph.decompress(data);
    var xmlDoc = mxUtils.parseXml(wfdataraw);
    var codec = new mxCodec(xmlDoc);
    codec.decode(xmlDoc.documentElement, graph.getModel());

    var model = graph.getModel();
			var currentSelectedVertex = null;
			var isStartOrEnd = false;
			var lookupWord = "Review";
			for (const property in model.cells)
			{
				if ( model.cells[property].value !== undefined && model.cells[property].value.tagName == "UserObject") {
					if	(model.cells[property].value.getAttribute("Key") == "STEP") {
						if (model.cells[property].value.getAttribute("Name") == lookupWord ) {
							currentSelectedVertex = model.cells[property];
							isStartOrEnd = false;
							break;
						}
					} else if (model.cells[property].value.getAttribute("Key") == "START"
					 || model.cells[property].value.getAttribute("Key") == "END") {
						if (model.cells[property].value.getAttribute("Name") == lookupWord ) {
							currentSelectedVertex = model.cells[property];
							isStartOrEnd = true;
							break;
						}
					}
				}
			}

			if ( currentSelectedVertex != null) {
				//Adds animation to edge shape and makes "pipe" visible
				var state = graph.view.getState(currentSelectedVertex);
				if (isStartOrEnd) {
					state.shape.node.getElementsByTagName('path')[0].removeAttribute('visibility');
					state.shape.node.getElementsByTagName('path')[0].setAttribute('stroke-width', '4');
					state.shape.node.getElementsByTagName('path')[0].setAttribute('stroke', 'gray');
					state.shape.node.getElementsByTagName('path')[0].setAttribute('class', 'flow');
				} else {

				var state = graph.view.getState(currentSelectedVertex);
				state.shape.node.getElementsByTagName('rect')[0].removeAttribute('visibility');
				state.shape.node.getElementsByTagName('rect')[0].setAttribute('stroke-width', '4');
				state.shape.node.getElementsByTagName('rect')[0].setAttribute('stroke', 'gray');
				state.shape.node.getElementsByTagName('rect')[0].setAttribute('class', 'flow');
				}
			}



    // var model = graph.getModel();
    // var currentSelectedVertex = null;
    // var isStartOrEnd = false;
    // var lookupWord = "Review";
    // for (const property in model.cells)
    // {
    //   if ( model.cells[property].value !== undefined && model.cells[property].value.tagName == "UserObject") {
    //     if	(model.cells[property].value.getAttribute("Key") == "STEP") {
    //       if (model.cells[property].value.getAttribute("Name") == lookupWord ) {
    //         currentSelectedVertex = model.cells[property];
    //         isStartOrEnd = false;
    //         break;
    //       }
    //     } else if (model.cells[property].value.getAttribute("Key") == "START"
    //       || model.cells[property].value.getAttribute("Key") == "END") {
    //       if (model.cells[property].value.getAttribute("Name") == lookupWord ) {
    //         currentSelectedVertex = model.cells[property];
    //         isStartOrEnd = true;
    //         break;
    //       }
    //     }
    //   }
    // }

    // if ( currentSelectedVertex != null) {
    //   //Adds animation to edge shape and makes "pipe" visible
    //   var state = graph.view.getState(currentSelectedVertex);
    //   if (isStartOrEnd) {
    //     state.shape.node.getElementsByTagName('path')[0].removeAttribute('visibility');
    //     state.shape.node.getElementsByTagName('path')[0].setAttribute('stroke-width', '4');
    //     state.shape.node.getElementsByTagName('path')[0].setAttribute('stroke', 'gray');
    //     state.shape.node.getElementsByTagName('path')[0].setAttribute('class', 'flow');
    //   } else {

    //   var state = graph.view.getState(currentSelectedVertex);
    //   state.shape.node.getElementsByTagName('rect')[0].removeAttribute('visibility');
    //   state.shape.node.getElementsByTagName('rect')[0].setAttribute('stroke-width', '4');
    //   state.shape.node.getElementsByTagName('rect')[0].setAttribute('stroke', 'gray');
    //   state.shape.node.getElementsByTagName('rect')[0].setAttribute('class', 'flow');
    //   }
    // }
  },
  methods: {
  }
};
</script>
